import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { ChevronRight } from "lucide-react";

/**
 * Card on the /health hub. Each card represents one sub-area (Training,
 * Nutrition, Recovery, Body) with a one-line headline + sub-line preview
 * that reads from a hook the parent passes in. The sparkline slot is filled
 * later by the per-sub-area home page.
 */
export function SubAreaCard({
  to,
  label,
  Icon,
  headline,
  subline,
  loading,
}: {
  to: string;
  label: string;
  Icon: LucideIcon;
  headline?: string | null;
  subline?: string | null;
  loading?: boolean;
}) {
  return (
    <Link
      to={to}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-2)",
        padding: "var(--space-5)",
        background: "var(--bg-2)",
        border: "1px solid var(--hair)",
        borderRadius: "var(--radius-card)",
        textDecoration: "none",
        color: "var(--fg)",
        minHeight: 132,
        position: "relative",
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "var(--space-2)",
          color: "var(--fg-3)",
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontSize: "var(--type-micro)",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "var(--fg-3)",
          }}
        >
          <Icon size={14} strokeWidth={1.6} aria-hidden /> {label}
        </span>
        <ChevronRight size={16} strokeWidth={1.5} />
      </header>
      <p
        style={{
          margin: 0,
          fontFamily: "var(--font-serif)",
          fontStyle: "italic",
          fontWeight: 500,
          fontSize: "var(--type-body-l)",
          color: "var(--fg)",
          minHeight: 26,
        }}
      >
        {loading ? "—" : headline ?? "No data yet"}
      </p>
      <p
        style={{
          margin: 0,
          fontSize: "var(--type-body-s)",
          color: "var(--fg-2)",
          lineHeight: 1.4,
        }}
      >
        {loading ? "Loading…" : subline ?? "Tap to view"}
      </p>
    </Link>
  );
}
